import { render, staticRenderFns } from "./PhotoViewer.vue?vue&type=template&id=a5762454&scoped=true&"
import script from "./PhotoViewer.vue?vue&type=script&lang=js&"
export * from "./PhotoViewer.vue?vue&type=script&lang=js&"
import style0 from "./PhotoViewer.vue?vue&type=style&index=0&id=a5762454&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5762454",
  null
  
)

export default component.exports